import { randomString } from '@/utils/tools';

/**
 * 生成用于神策与 Snowplow 业务埋点对账的 32 位事件 ID。
 */
export function generateEventId(): string {
  return randomString(32).slice(0, 32);
}

/**
 * 生成与参考事件 ID 不同的 32 位事件 ID，碰撞时继续生成。
 */
export function generateDistinctEventId(referenceEventId?: string): string {
  let eventId = generateEventId();

  while (eventId === referenceEventId) {
    eventId = generateEventId();
  }

  return eventId;
}

/**
 * 解析最终上报事件 ID；没有上游 ID 时统一使用 generateEventId 兜底。
 */
export function resolveTrackingEventId(eventId?: string): string {
  return eventId || generateEventId();
}
